// This import loads the firebase namespace along with all its type information.
import ViewStatistic from './view-statistic-model'

export async function load_viewStatistics(): Promise<ViewStatistic[]> {
  throw 'Not implemented'
}

export async function delete_viewStatistic(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_viewStatistic(): Promise<ViewStatistic> {
  throw 'Not implemented'
}
